module.exports = __webpack_public_path__ + "static/img/LOGO_1119_D7_arialNarrow.aef46bd.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/LOGO_1119_D7_arialNarrow.png
// module id = Okan
// module chunks = 1